import { render } from "./CourseInsightsExamParticipationRenderer.vue?vue&type=template&id=288612d0&ts=true"
import script from "./CourseInsightsExamParticipationRenderer.vue?vue&type=script&lang=ts"
export * from "./CourseInsightsExamParticipationRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__